import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ANIM_MS = 220;

/**
 * Modal genérico. Cabecera y pie quedan fijos y solo el cuerpo se desplaza:
 * lo resuelve el CSS (.popup-card en columna, .popup-body con flex:1 y
 * min-height:0), sin medir alturas desde JS.
 */
const Popup = ({ open, title, children, onClose, onConfirm, confirmText, cancelText, showConfirm = false, footerActions = null }) => {
  const { t } = useTranslation();
  const textoConfirmar = confirmText || t('comun.confirmar');
  const textoCancelar = cancelText || t('comun.cerrar');
  const [shouldRender, setShouldRender] = useState(open);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    let t;
    if (open) {
      // Mount and ensure enter animation
      setShouldRender(true);
      setExiting(false);
    } else if (shouldRender) {
      // Start exit animation then unmount
      setExiting(true);
      t = setTimeout(() => {
        setShouldRender(false);
        setExiting(false);
      }, ANIM_MS);
    }
    return () => clearTimeout(t);
  }, [open]);

  if (!shouldRender) return null;

  const handleBackground = (e) => {
    if (e.target.classList.contains('popup-overlay')) onClose();
  };

  return (
    <div className={`popup-overlay ${exiting ? 'popup-exit' : ''}`} onMouseDown={handleBackground}>
      <div className={`popup-card ${exiting ? 'popup-exit' : ''}`} role="dialog" aria-modal="true">
        <div className="popup-header">
          <h3>{title}</h3>
          <button className="popup-close" onClick={onClose} aria-label={t('comun.cerrar')}>×</button>
        </div>
        <div className="popup-body">{children}</div>
        <div className="popup-footer">
          {/* Custom actions provided by consumer (e.g. Crear usuario) */}
          {footerActions}
          {/* Default cancel/confirm buttons */}
          <button className="popup-btn popup-cancel" onClick={onClose}>{textoCancelar}</button>
          {showConfirm && <button className="popup-btn popup-confirm" onClick={onConfirm}>{textoConfirmar}</button>}
        </div>
      </div>
    </div>
  );
};

export default Popup;
